import React from 'react';
import icon from 'assets/images/softwares/GasLift1.png';

const Icon = ({ width }) => <img src={icon} alt="Gas Lift" width={width || '25'} />;

export default Icon;
